<template>
  <v-container>
    <h1 class="text-center">Historische Daten</h1>
    <v-toolbar flat>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Suche"
        single-line
        hide-details
      ></v-text-field>
    </v-toolbar>

    <!-- Desktop: Data Table -->
    <v-data-table
      v-if="!$vuetify.breakpoint.smAndDown"
      :search="search"
      :headers="headers"
      :items="historicalData"
      :multi-sort="true"
      :sort-by="['year', 'month', 'points']"
      :sort-desc="[true, true, true]"
      class="elevation-1"
    >
    </v-data-table>

    <!-- Mobile: Card List -->
    <template v-else>
      <v-card
        v-for="item in mobileItems"
        :key="item.id || (item.user_name + item.month + item.year)"
        class="mb-3"
        outlined
      >
        <v-card-title class="py-2">
          <v-icon left small>mdi-account</v-icon>
          <span class="body-1 font-weight-bold">{{ item.user_name }}</span>
        </v-card-title>
        <v-card-text class="pt-1 pb-2">
          <v-chip small color="primary" class="mr-2">
            <v-icon left x-small>mdi-star</v-icon>
            {{ item.points }} Punkte
          </v-chip>
          <v-chip small outlined>
            {{ item.month }}/{{ item.year }}
          </v-chip>
        </v-card-text>
      </v-card>
      <v-alert v-if="mobileItems.length === 0" type="info" class="mt-2">
        Keine Einträge gefunden.
      </v-alert>
    </template>
  </v-container>
</template>

<script>
import BackendService from '@/services/BackendService';

export default {
  name: 'HistoricalData',
  data: () => ({
    historicalData: [],
    search: null,
    headers: [
      { text: 'Viewer', value: 'user_name', align: 'center' },
      { text: 'Punkte', value: 'points', align: 'center' },
      { text: 'Monat', value: 'month', align: 'center' },
      { text: 'Jahr', value: 'year', align: 'center' },
    ],
  }),
  mounted() {
    BackendService.loadHistoricalData(1).then((data) => {
      this.historicalData = data.data;
    }).catch((err) => {
      console.error('Fehler beim Laden der historischen Daten:', err);
    });
  },
  computed: {
    mobileItems() {
      if (!this.search) return this.historicalData;
      const s = this.search.toLowerCase();
      return this.historicalData.filter((item) => (item.user_name && item.user_name.toLowerCase().includes(s))
        || String(item.points).includes(s)
        || String(item.month).includes(s)
        || String(item.year).includes(s));
    },
  },
};
</script>
<style scoped>
</style>
